<template>
  <div class="base-box">
    <van-field
      v-model="params.mobile"
      class="input-item"
      label="手机号"
      placeholder="请输入您的手机号码"
    ></van-field>
    <van-field
      class="input-item"
      v-model="params.code"
      label="验证码"
      placeholder="请输入短信验证码"
    >
      <van-button slot="button" size="small" type="primary" @click="getCode">
        <template v-if="!isSpend">获取验证码</template>
        <template v-else>( {{ time }} )</template>
      </van-button>
    </van-field>
    <van-button class="nextBtn" type="primary" size="large" @click="submit">下一步</van-button>
  </div>
</template>

<script>
import { Field, Button, Toast, Icon } from "vant";
import {
  getRegisterCode,
  checkMobile,
  verifyRegisterCode,
  fastRegisterMember,
} from "@/api/login";

export default {
  data() {
    return {
      isSpend: false,
      time: 60,
      params: {
        mobile: "",
        code: "",
      },
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  methods: {
    async getCode() {
      let mobile = this.params.mobile;

      if (this.isSpend) {
        return;
      }

      if (!this.$regexp.mobile(mobile)) {
        Toast("请输入正确的手机号！");
        return false;
      }

      await this.checkMobiles(mobile);

      getRegisterCode({ mobile }).then((res) => {
        if (res.success) {
          this.isSpend = true;
          this.time = 60;
          this.count();
        }
      });
    },
    checkMobiles(mobile) {
      let params = {
        mobile,
      };

      return new Promise((resolve) => {
        checkMobile(params).then((res) => {
          if (!res.result && res.success) {
            this.$tips.warm("该手机号码还未注册！");
          } else {
            resolve();
          }
        });
      });
    },
    count() {
      --this.time;
      if (this.time > 0) {
        setTimeout(() => {
          this.count();
        }, 1000);
      } else {
        this.isSpend = false;
      }
    },
    submit() {
      let value = this.value;
      let isMobile = this.$regexp.mobile(this.params.mobile);
      let code = { code: this.params.code };
      if (!this.params.mobile || !isMobile) {
        Toast("请输入正确的手机号码！");
        return;
      }

      if (!this.params.code) {
        Toast("请输入验证码！");
        return;
      }

      verifyRegisterCode(code).then((res) => {
        if (res.success) {
          this.$emit("success", this.value);
        } else {
          Toast.fail("验证码不正确！");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.input-item {
  padding: 0;
  padding-bottom: 12px;
  i {
    color: #aaa;
  }
  & + .input-item {
    margin-top: 20px;
  }
}
/deep/.van-field__label {
  width: 2.2rem;
}
.successedBtn {
  margin: 30px 0 25px 0 !important;
}
.rule-box {
  justify-content: center;
  margin-bottom: 20px;
}
.nextBtn {
  margin-top: 60px;
}
.type_box{ overflow: hidden; border-bottom: #dfdfdf solid 1px; margin-bottom: 30px; margin-top: -10px;}
.type_box p{ float: left; font-size: 15px; height: 50px; line-height: 50px; color: #333;}
/deep/.van-field__label{ width:2.2rem}
</style>
